import { render, staticRenderFns } from "./AreaSidebar.vue?vue&type=template&id=b7eafecc&scoped=true&"
import script from "./AreaSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./AreaSidebar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AreaSidebar.vue?vue&type=style&index=0&id=b7eafecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eafecc",
  null
  
)

export default component.exports